<template>
  <div class="dtablerow">

    <!-- Left Panel -->
    <aside id="left-panel" class="left-panel">
      <LeftMenu/>
    </aside><!-- /#left-panel -->
    <!-- Left Panel -->

    <!-- Right Panel -->
    <div id="right-panel" class="right-panel">
      <!-- Header-->
      <header id="header" class="header">
        <div class="header-menu">
          <div class="col-sm-7">
            <MenuToggle/>
            <div class="header-left">
              <HeaderSearch/>
              <HeaderCompanySelector/>
              <HeaderNotification/>
              <HeaderMessages/>
            </div>
          </div>
          <div class="col-sm-5">
            <User/>
            <LngChooser/>
          </div>
        </div>
      </header><!-- /header -->
      <!-- Header-->
      <Breadcrumbs/>
      <div class="content mt-3">
        <div class="animated fadeIn" v-if="this.hasRole">
          <!-- content place -->
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('usersettings.title')}}</strong>
                <div class="float-right">
                  <template v-if="advancedfeatures">
                    <router-link :to="{ path: '/keys'}" class="btn btn-link btn-sm"><i class="fa fa-link"></i> {{$t('Keys.title')}}</router-link>
                  </template>

                </div>
              </div>

              <template v-if="true">
                <div class="card-body card-block">

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="user_sumprice_huf_number_of_decimals" class=" form-control-label">{{ $t('usersettings.sumprice_huf_number_of_decimals') }}</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="user_sumprice_huf_number_of_decimals" type="text" id="user_sumprice_huf_number_of_decimals" placeholder="" class="form-control" name="user_sumprice_huf_number_of_decimals"
                             v-validate="'numeric'" v-bind:class="{'is-invalid':errors.has('user_sumprice_huf_number_of_decimals')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="user_sumprice_eur_number_of_decimals" class=" form-control-label">{{ $t('usersettings.sumprice_eur_number_of_decimals') }}</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="user_sumprice_eur_number_of_decimals" type="text" id="user_sumprice_eur_number_of_decimals" placeholder="" class="form-control" name="user_sumprice_eur_number_of_decimals"
                             v-validate="'numeric'" v-bind:class="{'is-invalid':errors.has('user_sumprice_eur_number_of_decimals')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="user_sumprice_usd_number_of_decimals" class=" form-control-label">{{ $t('usersettings.sumprice_usd_number_of_decimals') }}</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="user_sumprice_usd_number_of_decimals" type="text" id="user_sumprice_usd_number_of_decimals" placeholder="" class="form-control" name="user_sumprice_usd_number_of_decimals"
                             v-validate="'numeric'" v-bind:class="{'is-invalid':errors.has('user_sumprice_usd_number_of_decimals')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                </div>

              </template>

              <div class="card-footer">
                  <button type="submit" class="btn btn-primary btn-sm" v-on:click="saveAllUserSettings">
                    <i class="fa fa-dot-circle-o"></i> {{$t('global.save')}}
                  </button>
              </div>

            </div>
          </div>


        </div><!-- .animated -->

        <div class="animated fadeIn" v-if="!this.hasRole">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemcheckstitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemchecks')}}</div>
            </div>
          </div>
        </div><!-- .animated -->


      </div><!-- .content -->
    </div><!-- /#right-panel -->
    <!-- Right Panel -->
  </div>
</template>

<script>
  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderCompanySelector from '@/components/HeaderCompanySelector.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
  import TableDatatableJs from '@/components/TableDatatableJs.vue';
  import MenuToggle from '@/components/MenuToggle.vue';
  import AlertInPage from '@/components/AlertInPage.vue';
  import Api from '@/api/Api';
  import Helper from '@/helper/Helper';
  import SettingsContainer from '@/helper/SettingsContainer';
  import HelperRole from "@/helper/HelperRole";
  import InputText from '@/components/InputText.vue';

  export default {
    name: 'Usersettings',
    data() {
      return {
        Helper: Helper
        , user_sumprice_huf_number_of_decimals: 0
        , user_sumprice_eur_number_of_decimals: 2
        , user_sumprice_usd_number_of_decimals: 2
        ,
        hasSavedAlert: true,
        data: [],
        AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          msgPre: "",
          msgPost: "",
          delay: 2500,
        },
        advancedfeatures: false,
        HelperRole: HelperRole
        , hasRole: false
        , hasCompany: false
        , state: {}
        , stateHash: ""
        , openadvancedfeatures: 0
      };
    },
    watch: {
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          modul.handleRights();
          modul.getAllUserSettings();
        }
      },
      'hasRole': function (newVal, oldVal) {
        const modul = this;
        if (newVal && !oldVal) {
          if (modul.hasRole && modul.hasCompany) {
            modul.init();
          }
        }
      },
      'advancedfeatures': function (newVal, oldVal) {
        const modul = this;
        if (!newVal) {
          modul.APIurlType = "live";
          modul.openadvancedfeatures = 1
        }
      },
      data: function (newData, oldData) {
        const modul = this;
      },

    },
    mounted() {
      const modul = this;
      modul.handleRights();
    },
    methods: {
      handleRights(){
        const modul = this;
        modul.state = Object.assign({}, modul.$store.state);
        if (HelperRole.hasRights(modul.state, [14], true)) {
          modul.hasRole = true;
        }
//        if (modul.state.id_company) {
//          modul.hasCompany = true;
//        }
        if (modul.hasRole) {
          modul.init();
        }
      },
      init(){
        const modul = this;
        modul.getAllUserSettings();
      },
      getAllUserSettings(){
        const modul = this;
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        Api.getAllUserSettings({}).then(function (res) {
          if (res && res.result && res.data) {

            modul.user_sumprice_huf_number_of_decimals = Helper.String(res.data.user_sumprice_huf_number_of_decimals);
            modul.user_sumprice_eur_number_of_decimals = Helper.String(res.data.user_sumprice_eur_number_of_decimals);
            modul.user_sumprice_usd_number_of_decimals = Helper.String(res.data.user_sumprice_usd_number_of_decimals);

            modul.data = res.data;

            if (modul.data && typeof modul.data === "object" && Object.keys(modul.data).length > 0) {
              modul.hasSavedAlert = false;
            }
            modul.AlertInPage.msg = "";

          } else {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
          }
        }, function (e) {
          modul.AlertInPage.msg = "form.save_error";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(modul.AlertInPage.delay));
        });
      },

      saveAllUserSettings(cb){
        const modul = this;
        const data = {};
        data.user_sumprice_huf_number_of_decimals = modul.user_sumprice_huf_number_of_decimals;
        data.user_sumprice_eur_number_of_decimals = modul.user_sumprice_eur_number_of_decimals;
        data.user_sumprice_usd_number_of_decimals = modul.user_sumprice_usd_number_of_decimals;

        const postObj = {};
        postObj.id_company = modul.$store.state.id_company;
        postObj.data = data;
        const alertId = Math.random();
        modul.$eventBus.$emit('globalAlert', {
          id: alertId,
          type: "warning",
          msgPreInner: "",
          msg: "form.in_progress",
          msgPostInner: "",
          delay: 50000
        });
        Api.saveAllUserSettings(postObj).then(function (res) {
          if (res && res.result) {
            modul.$eventBus.$emit('globalAlert', {
              id_delete: alertId,
              type: "success",
              msgPreInner: "",
              msg: "form.save_succes",
              msgPostInner: "",
              delay: 5000
            });
            Api.healthCheck({}).then(function (res) {
                HelperRole.healthCheckHandler(modul, res);
              }, function (res) {
                HelperRole.healthCheckHandler(modul, res);
              }
            );
            if (typeof cb === "function") {
              cb();
            }
          } else {
            modul.$eventBus.$emit('globalAlert', {
              id_delete: alertId,
              type: "danger",
              msgPreInner: "",
              msg: "form.save_error",
              msgPostInner: "",
              delay: 5000
            });
          }
        }, function (e) {
          modul.$eventBus.$emit('globalAlert', {
            id_delete: alertId,
            type: "danger",
            msgPreInner: "",
            msg: "form.save_error",
            msgPostInner: "",
            delay: 5000
          });
        });
      },

    },

    components: {
      LeftMenu,
      HeaderSearch,
      HeaderCompanySelector,
      HeaderNotification,
      HeaderMessages,
      User,
      LngChooser,
      Breadcrumbs,
      TableDatatableJs,
      MenuToggle,
      AlertInPage,
      InputText,
    },
  };
</script>

<style scoped>
  .inputpositioner {
    flex: 1 1 auto;
    width: 1%;
  }

  .input-group-addon-danger {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
  }

  .input-group-addon-success {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
  }

  .contentFieldsContainer tr td {
    padding: 2px 0;
  }
</style>






